export const products = [
  {
    id: 1,
    name: "Ekler(Adet)",
    image: "/images/foods/tatli-lezzetler/ekler.webp",
    description: "Ekler",
    price: "60₺",
  },
  {
    id: 2,
    name: "Süt Burger",
    image: "/images/foods/tatli-lezzetler/sut-burger.webp",
    description: "",
    price: "80₺",
  },
  {
    id: 3,
    name: "Waffle",
    image: "/images/foods/tatli-lezzetler/waffle.webp",
    description: "",
    price: "300₺",
  },
  {
    id: 4,
    name: "Dondurma",
    image: "/images/foods/tatli-lezzetler/dondurma.webp",
    description: "",
    price: "250₺",
  },
  {
    id: 5,
    name: "Top Dondurma",
    image: "/images/foods/tatli-lezzetler/top-dondurma.webp",
    description: "",
    price: "80₺",
  },
  {
    id: 6,
    name: "Karışık Çerez",
    image: "/images/foods/tatli-lezzetler/karisik-cerez.webp",
    description: "",
    price: "230₺",
  },
  {
    id: 7,
    name: "Magnolia",
    image: "/images/foods/tatli-lezzetler/magnolia.webp",
    description: "",
    price: "230₺",
  },
  {
    id: 8,
    name: "Çikolatalı Rallı",
    image: "/images/foods/tatli-lezzetler/cikolatali-ralli.webp",
    description: "",
    price: "340₺",
  },
  {
    id: 9,
    name: "Doğum Günü Pastası",
    image: "/images/foods/tatli-lezzetler/dogum-gunu-pastasi.webp",
    description: "",
    price: "Fiyat Alınız",
  },
  {
    id: 10,
    name: "Jakonte",
    image: "/images/foods/tatli-lezzetler/jakonte.webp",
    description: "",
    price: "300₺",
  },
  {
    id: 12,
    name: "Dubai Cheesecake",
    image: "/images/foods/tatli-lezzetler/dubai-cheesecake.webp",
    description: "",
    price: "350₺",
  },
  {
    id: 13,
    name: "Antebim",
    image: "/images/foods/tatli-lezzetler/antebim.webp",
    description: "",
    price: "400₺",
  },
  {
    id: 14,
    name: "Antep Fıstığı",
    image: "/images/foods/tatli-lezzetler/antep-fistigi.webp",
    description: "",
    price: "250₺",
  },
  {
    id: 15,
    name: "Şekerpare",
    image: "/images/foods/tatli-lezzetler/sekerpare.webp",
    description: "",
    price: "240₺",
  },
  {
    id: 16,
    name: "Antep Fıstıklı Dondurma",
    image: "/images/foods/tatli-lezzetler/dondurma.webp",
    description: "",
    price: "300₺",
  },
  {
    id: 17,
    name: "Sütlü Baklava",
    image: "/images/foods/tatli-lezzetler/sutlu-baklava.webp",
    description: "",
    price: "300₺",
  },
  {
    id: 18,
    name: "Frambuazlı Cheesecake",
    image: "/images/foods/tatli-lezzetler/frambuazli-cheesecake.webp",
    description: "",
    price: "270₺",
  },
  {
    id: 19,
    name: "Dondurmalı Brownie",
    image: "/images/foods/tatli-lezzetler/dondurmali-brownie.webp",
    description: "Dondurmalı Brownie",
    price: "250₺",
  },
  {
    id: 20,
    name: "Burma Kadayıf",
    image: "/images/foods/tatli-lezzetler/burma-kadayif.webp",
    description: "Burma Kadayıf",
    price: "300₺",
  },
  {
    id: 21,
    name: "Künefe",
    image: "/images/foods/tatli-lezzetler/kunefe.webp",
    description: "Künefe",
    price: "250₺",
  },
  {
    id: 22,
    name: "Fıstık Rüyası",
    image: "/images/foods/tatli-lezzetler/fistik-ruyasi.webp",
    description: "Fıstık Rüyası",
    price: "400₺",
  },
  {
    id: 23,
    name: "Sütlaç",
    image: "/images/foods/tatli-lezzetler/sutlac.webp",
    description: "Sütlaç",
    price: "170₺",
  },
  {
    id: 24,
    name: "Tiramisu",
    image: "/images/foods/tatli-lezzetler/tiramisu.webp",
    description: "Tiramisu",
    price: "280₺",
  },
  {
    id: 25,
    name: "Mozaik Pasta",
    image: "/images/foods/tatli-lezzetler/mozaik-pasta.webp",
    description: "Mozaik Pasta",
    price: "220₺",
  },
  {
    id: 26,
    name: "Supangle",
    image: "/images/foods/tatli-lezzetler/supangle.webp",
    description: "Supangle",
    price: "200₺",
  },
  {
    id: 27,
    name: "Limonlu Cheesecake",
    image: "/images/foods/tatli-lezzetler/cheesecake.webp",
    description: "Cheesecake",
    price: "250₺",
  },
  {
    id: 28,
    name: "Lotus",
    image: "/images/foods/tatli-lezzetler/lotus.webp",
    description: "Lotus",
    price: "280₺",
  },
  {
    id: 29,
    name: "Sufle",
    image: "/images/foods/tatli-lezzetler/sufle.webp",
    description: "Sufle",
    price: "300₺",
  },
  {
    id: 30,
    name: "Malaga",
    image: "/images/foods/tatli-lezzetler/malaga.webp",
    description: "",
    price: "250₺",
  },
  {
    id: 31,
    name: "Meyve Tabağı",
    image: "/images/foods/tatli-lezzetler/meyve-tabagi.webp",
    description: "",
    price: "300₺",
  },

  // Devamını ekleyebilirsin...
];
